module.exports = __webpack_public_path__ + "img/step5-fr@2x.2c706b9b.webp";